// booking.lang.es.js
const bookingES = {
	weekLabel: "{start} – {end}",
	noSlots: "No hay horarios disponibles",
	staff: {
		title: "Personal",
		any: "Cualquier personal",
	},
	services: {
		title: "Servicios",
		add: "+ Añadir servicio",
		selected: "{name} • {duration} min — ${price}",
	},
	guest: {
		title: "Tus Datos",
		fullName: "Nombre completo",
		email: "Correo electrónico",
	},
	buttons: {
		confirm: "Confirmar Reserva",
		confirmReschedule: "Confirmar Reprogramación",
		close: "Cerrar",
	},
	toast: {
		noServiceOrTime: "Selecciona al menos un servicio y un horario",
		missingService: "Por favor selecciona al menos un servicio.",
		missingTime: "Por favor selecciona una hora.",
		missingGuest: "Por favor ingresa tu nombre y correo",
		noStaff: "No hay personal disponible para esa hora",
		pastTime: "No puedes reservar una hora en el pasado.",
		bookingConfirmed: "¡Reserva confirmada! Correo enviado.",
		rescheduled: "¡Reserva reprogramada con éxito!",
		couldNotReschedule: "No se pudo reprogramar la reserva",
		couldNotConfirm: "No se pudo confirmar la reserva",
		timeInvalidated: "La hora seleccionada ya no está disponible para los servicios elegidos.",
		missingStaff: "Por favor selecciona al menos un miembro del personal",
	},
	timeFilters: {
		morning: "Mañana",
		afternoon: "Tarde",
		evening: "Noche",
	},
	summary: {
		noServices: "Ningún servicio seleccionado",
		oneService: "1 servicio",
		multipleServices: "{n} servicios",
	},
};

export default bookingES;
